import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectFloorNumbersState } from '../selectors';

export const getData = createSelector(selectFloorNumbersState, (state: State) => state.data);

export const getError = createSelector(selectFloorNumbersState, (state: State) => state.error);

export const getLoading = createSelector(selectFloorNumbersState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectFloorNumbersState, (state: State) => fn(state.data));
